import { render, staticRenderFns } from "./storeConsumer.vue?vue&type=template&id=2e25c668&scoped=true&"
import script from "./storeConsumer.vue?vue&type=script&lang=js&"
export * from "./storeConsumer.vue?vue&type=script&lang=js&"
import style0 from "./storeConsumer.vue?vue&type=style&index=0&id=2e25c668&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e25c668",
  null
  
)

export default component.exports